import { useContext } from "react";

import { AddBoardContext } from "./AddBoardContext";

export function useAddBoard() {
  const context = useContext(AddBoardContext);
  if (!context) {
    throw new Error("useAddBoard must be used within a AddBoardProvider");
  }
  return context;
}
